// Route table. Mirrors frontend-design §2 Routes & Pages.

import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import {
  HomeRedirect,
  RequireAdmin,
  RequireDashboard,
  RequireNonMember,
} from '@/routes/guards';
import { AgreementListPage } from '@/pages/AgreementListPage';
import { AgreementCreatePage } from '@/pages/AgreementCreatePage';
import { AgreementDetailPage } from '@/pages/AgreementDetailPage';
import { AmendmentCreatePage } from '@/pages/AmendmentCreatePage';
import { MyAssignmentsPage } from '@/pages/MyAssignmentsPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PeopleAdminPage } from '@/pages/PeopleAdminPage';
import { CompaniesAdminPage } from '@/pages/CompaniesAdminPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomeRedirect />} />
        <Route path="agreements" element={<AgreementListPage />} />
        <Route
          path="agreements/new"
          element={
            <RequireNonMember>
              <AgreementCreatePage />
            </RequireNonMember>
          }
        />
        <Route path="agreements/:id" element={<AgreementDetailPage />} />
        <Route
          path="agreements/:id/amend"
          element={
            <RequireNonMember>
              <AmendmentCreatePage />
            </RequireNonMember>
          }
        />
        <Route path="me/assignments" element={<MyAssignmentsPage />} />
        <Route
          path="dashboard"
          element={
            <RequireDashboard>
              <DashboardPage />
            </RequireDashboard>
          }
        />
        <Route
          path="admin/people"
          element={
            <RequireAdmin>
              <PeopleAdminPage />
            </RequireAdmin>
          }
        />
        <Route
          path="admin/companies"
          element={
            <RequireAdmin>
              <CompaniesAdminPage />
            </RequireAdmin>
          }
        />
        <Route path="not-found" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
